import {
  Title,
  TextInput,
  Button,
  Container,
  Stack,
  Group,
  Text,
  ActionIcon,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";
import { createMcpServer } from "./mcpServerApi";
import { notifications } from "@mantine/notifications";

function headersListToDict(list) {
  if (!list?.length) return undefined;
  const dict = {};
  for (const { key, value } of list) {
    if (key) dict[key] = value;
  }
  return Object.keys(dict).length > 0 ? dict : undefined;
}

export default function McpServerCreate() {
  const [, setLocation] = useLocation();

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      name: "",
      url: "",
      headers: [],
    },
    validate: {
      name: (v) => (v ? null : "Name is required"),
      url: (v) =>
        v && (v.startsWith("http://") || v.startsWith("https://"))
          ? null
          : "Valid URL required",
    },
  });

  const handleSubmit = async (values) => {
    try {
      await createMcpServer({
        ...values,
        headers: headersListToDict(values.headers),
      });
      setLocation("/mcp-servers");
    } catch (err) {
      notifications.show({
        title: "Error",
        message: err.message,
        color: "red",
      });
    }
  };

  return (
    <Container size="sm">
      <Title order={1} mb="md">
        Add MCP Server
      </Title>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <TextInput
            label="Name"
            placeholder="My MCP Server"
            description="A friendly name for this server"
            {...form.getInputProps("name")}
            radius="md"
          />
          <TextInput
            label="URL"
            placeholder="https://mcp.example.com/api/mcp"
            description="The Streamable HTTP endpoint of the MCP server"
            {...form.getInputProps("url")}
            radius="md"
          />

          <Group mt="md" justify="space-between" align="center">
            <Text fw={500}>Authentication Headers</Text>
            <Button
              variant="outline"
              size="compact-sm"
              onClick={() =>
                form.insertListItem("headers", { key: "", value: "" })
              }
            >
              Add Header
            </Button>
          </Group>
          {form.values.headers?.map((_, idx) => (
            <Group key={idx} mb="xs" align="flex-end">
              <TextInput
                label="Header"
                placeholder="Authorization"
                {...form.getInputProps(`headers.${idx}.key`)}
                radius="md"
                style={{ flex: 1 }}
              />
              <TextInput
                label="Value"
                placeholder="Bearer your-token-here"
                {...form.getInputProps(`headers.${idx}.value`)}
                radius="md"
                style={{ flex: 2 }}
              />
              <ActionIcon
                variant="subtle"
                color="red"
                mb={4}
                onClick={() => form.removeListItem("headers", idx)}
              >
                <IconTrash size={16} />
              </ActionIcon>
            </Group>
          ))}

          <Button mt="lg" type="submit">
            Add Server
          </Button>
        </Stack>
      </form>
    </Container>
  );
}
